module.exports = __webpack_public_path__ + "img/service-resource11.30d98294.jpg";